
/* Sort by discount. Shopify offers no discount sort, so the option is added to
   the dropdown and the rendered grid is reordered here. Applies to the products
   currently on the page. */
(function () {
  var VALUE = 'discount-desc';
  function pct(card) {
    var m = (card.textContent || '').match(/Save\s+(\d+)%/);
    return m ? parseInt(m[1], 10) : -1;
  }
  function grid() {
    var p = document.querySelector('.product--price-container');
    while (p && p.parentElement) {
      if (p.parentElement.querySelectorAll('.product--price-container').length > 2 &&
          p.parentElement.children.length > 2) return p.parentElement;
      p = p.parentElement;
    }
    return null;
  }
  function apply() {
    var g = grid();
    if (!g) return;
    Array.prototype.slice.call(g.children)
      .sort(function (a, b) { return pct(b) - pct(a); })
      .forEach(function (n) { g.appendChild(n); });
    g.setAttribute('data-sorted-by-discount', 'true');
  }
  function active() {
    return new URLSearchParams(window.location.search).get('sort_by') === VALUE;
  }
  function take(e) {
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', VALUE);
    history.replaceState({}, '', u);
    e.preventDefault(); e.stopPropagation();
    apply();
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'sort_by' && e.target.value === VALUE) take(e);
  }, true);
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-value="' + VALUE + '"], a[href*="sort_by=' + VALUE + '"]')) take(e);
  }, true);
  function init() { if (active()) apply(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  new MutationObserver(function () {
    if (active() && !document.querySelector('[data-sorted-by-discount]')) apply();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
